/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I4_LabelInputs */

const tr_kullanim_s2_i4_label = /** @type {(inputs: Kullanim_S2_I4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçerik:`)
};

const en_kullanim_s2_i4_label = /** @type {(inputs: Kullanim_S2_I4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content:`)
};

const de_kullanim_s2_i4_label = /** @type {(inputs: Kullanim_S2_I4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt:`)
};

const ru_kullanim_s2_i4_label = /** @type {(inputs: Kullanim_S2_I4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент:`)
};

/**
* | output |
* | --- |
* | "Content:" |
*
* @param {Kullanim_S2_I4_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i4_label = /** @type {((inputs?: Kullanim_S2_I4_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I4_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i4_label(inputs)
	if (locale === "de") return de_kullanim_s2_i4_label(inputs)
	if (locale === "ru") return ru_kullanim_s2_i4_label(inputs)
	return tr_kullanim_s2_i4_label(inputs)
});